module.exports = __webpack_public_path__ + "img/blue_149.660ad227.png";